import styled, {css} from 'styled-components'

export const StyledFilterSection = styled.div<{$withSeparator?: boolean}>`
    ${({theme, $withSeparator}) => css`
        display: flex;
        flex-direction: column;
        gap: ${theme.spacing * 2}px;
        ${$withSeparator &&
        css`
            border-top: 1px solid ${theme.palette.neutral['100']};
            padding-top: ${theme.spacing * 4}px;
        `}
    `}
`

export const StyledSectionHeading = styled.h3`
    ${({theme}) => css`
        font-size: 11px;
        line-height: 16px;
        font-weight: 500;
        letter-spacing: 0.05em;
        text-transform: uppercase;
        color: ${theme.palette.neutral['500']};
    `}
`

export const StyledFieldsGrid = styled.div<{$columns: 2 | 3 | 4}>`
    ${({theme, $columns}) => css`
        display: grid;
        grid-template-columns: repeat(${$columns}, minmax(0, 1fr));
        gap: ${theme.spacing * 3}px;
        align-items: start;

        ${theme.mediaQueries.m} {
            grid-template-columns: repeat(${$columns >= 3 ? 2 : 1}, minmax(0, 1fr));
        }
    `}
`

// Wrapper for BE-gated (disabled) fields so the "Non ancora disponibile"
// tooltip fires on hover even though the inner control is disabled.
export const StyledGatedField = styled.div<{$inline?: boolean}>`
    ${({theme, $inline}) => css`
        cursor: help;
        width: ${$inline ? 'fit-content' : '100%'};
        margin-top: ${$inline ? `${theme.spacing * 3}px` : 0};
    `}
`

export const StyledToggleBlock = styled.div`
    ${({theme}) => css`
        border-top: 1px solid ${theme.palette.neutral['100']};
        padding-top: ${theme.spacing * 3}px;
        margin-top: ${theme.spacing * 4}px;
        display: flex;
        flex-direction: column;
        gap: ${theme.spacing * 2}px;
    `}
`

export const StyledPriSubGroup = styled.div`
    ${({theme}) => css`
        padding: ${theme.spacing * 3}px;
        border-radius: 6px;
        background: ${theme.palette.neutral['50']};
        border: 1px solid ${theme.palette.neutral['100']};
        display: flex;
        flex-direction: column;
        gap: ${theme.spacing * 3}px;

        & > strong {
            ${theme.typography.textXs};
            font-weight: 500;
            color: ${theme.palette.neutral['700']};
        }
    `}
`

export const StyledAddPathologyButton = styled.button`
    ${({theme}) => css`
        display: inline-flex;
        align-items: center;
        gap: ${theme.spacing * 1.5}px;
        align-self: flex-start;
        border: none;
        background: transparent;
        cursor: pointer;
        padding: 0;
        ${theme.typography.textSm};
        font-weight: 500;
        color: ${theme.palette.primary['600']};

        &:hover {
            color: ${theme.palette.primary['700']};
        }

        & svg {
            width: 14px;
            height: 14px;
        }
    `}
`

export const StyledRemovablePathology = styled.div`
    position: relative;

    & > button {
        ${({theme}) => css`
            position: absolute;
            top: 0;
            right: 0;
            z-index: 1;
            display: inline-flex;
            border: none;
            background: transparent;
            cursor: pointer;
            padding: ${theme.spacing * 0.5}px;
            color: ${theme.palette.neutral['400']};

            &:hover {
                color: ${theme.palette.neutral['700']};
            }

            & svg {
                width: 14px;
                height: 14px;
            }
        `}
    }
`

export const StyledInlineBadgeLabel = styled.span`
    ${({theme}) => css`
        display: inline-flex;
        align-items: center;
        gap: ${theme.spacing * 1.5}px;
    `}
`

export const StyledRoleBadge = styled.span<{$accent: 'teal' | 'indigo' | 'purple'}>`
    ${({theme, $accent}) => css`
        padding: ${theme.spacing * 0.5}px ${theme.spacing * 1.5}px;
        border-radius: 4px;
        font-size: 10px;
        line-height: 12px;
        font-weight: 500;
        letter-spacing: 0.05em;
        background: ${theme.palette[$accent]['100']};
        color: ${theme.palette[$accent]['700']};
    `}
`
